import { z } from 'zod'
import { type QuickMdState } from '@/app/store'
import { useAppSelector } from '@/redux/hooks/useAppSelector'
import { profilePermissions } from '@/utils/constants'

/**
 * The logged-in admin's profile (`GET /api/v1/profile`) is stored untyped in the
 * legacy Redux slice, so we narrow the only field we care about at the boundary.
 */
const ProfilePermissionsSchema = z.object({
  Permissions: z.array(z.string()).nullish(),
})

const selectAdminProfile = (state: QuickMdState) => state.accountSettings.adminProfile

/**
 * True when the logged-in admin holds `patient.package.edit` — the permission the
 * backend requires to adjust a plan's visit balance or cancel it (QMD-4371). The
 * API is the source of truth (403 Permission); this gates the UI affordance so a
 * staff member without it never sees the edit action.
 */
export function useCanEditPackage(): boolean {
  const adminProfile = useAppSelector(selectAdminProfile)
  const result = ProfilePermissionsSchema.safeParse(adminProfile)
  if (!result.success) return false
  return result.data.Permissions?.includes(profilePermissions.CAN_EDIT_PACKAGE) ?? false
}
